// extracted by mini-css-extract-plugin
module.exports = {"cfgScale":"CFGScaleInput_cfgScale__3EEFj","btn":"CFGScaleInput_btn__dcN8N","active":"CFGScaleInput_active__iPP6c"};